import { render, staticRenderFns } from "./travelCases.vue?vue&type=template&id=5c43a717&scoped=true"
import script from "./travelCases.vue?vue&type=script&lang=js"
export * from "./travelCases.vue?vue&type=script&lang=js"
import style0 from "./travelCases.vue?vue&type=style&index=0&id=5c43a717&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c43a717",
  null
  
)

export default component.exports